import { Link } from "react-router-dom";
import logo_fi_lvv from "../../img/logo_fi_lvv.svg";
import "./newHeader.css";

const NewHeader = (props) => {
  const { headingLevel, title } = props;
  const Title = headingLevel;

  return (
    <header className="header_new">
      <Title style={{ display: "none" }}>{title}</Title>
      <div className="header__nav">
        <div>
          <Link to="/">
            <img className="logo" alt={"Lupa- ja valvontavirasto"} src={logo_fi_lvv} />
          </Link>
        </div>
      </div>
    </header>
  );
};

export default NewHeader;
